module.exports = __webpack_public_path__ + "static/img/organism-h5-4.3257076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-4.png
// module id = QuwU
// module chunks = 34